

import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'


export default {
  name: 'app',
  data () {
    return {
      showTabbar: false
    }
  },
  components: {
    Tabbar,
    TabbarItem
  },
  watch: {
    $route (to, from) {
      this.showTabbar = !['register', 'confirm', 'error'].includes(to.name)
    }
  }
}



// WEBPACK FOOTER //
// ./src/App.vue